import type { HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

export const ContentBox = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("rounded-2xl bg-bg-popover p-6", className)}
      {...props}
    />
  )
}
